/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useHotkeys } from 'react-hotkeys-hook';
import { ref, onValue, onChildChanged } from 'firebase/database';
import i18n from 'components/Translation/Translate';
import Swal from 'sweetalert2';

// @mui material components
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Icon from '@mui/material/Icon';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Badge from '@mui/material/Badge';
import Chip from '@mui/material/Chip';
import { Alert, Grow } from '@mui/material';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDInput from 'components/MDInput';

// Authentication layout components
import { setDevice } from 'redux/actions/appAction';
import * as Defi from 'services/Define';
import * as Func from 'services/Function';
import { FetchData } from 'services/Request';
import db from 'services/Firebase';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import PageLayout from 'examples/LayoutContainers/PageLayout';
import Navbar from 'examples/Navbars/NavBar';

import './PointOfSale.css';

import PosQuantity from './PosQuantity';
import PosCash from './PosCash';
import PosTransfer from './PosTransfer';
import PosCreditCard from './PosCreditCard';
import PosShortKey from './PosShortKey';
import PosStay from './PosStay';
import PosProduct from './PosProduct';
import PosReturn from './PosReturn';
import PosApprove from './PosApprove';
import PosCloseShift from './PosCloseShift';
import PosDropMoney from './PosDropMoney';
import PosPrintChange from './PosPrintChange';
import PosCheckPro from './PosCheckPro';
import PosCancelBill from './PosCancelBill';
import PosDiscount from './PosDiscount';
import PosMessage from './PosMessage';
import PosCoupon from './PosCoupon';
import PosPayment from './PosPayment';
import PosClient from './PosClient';
import PosSelectFree from './PosSelectFree';
import PosSales from './PosSales';
import PosBillRecovery from './PosBillRecovery';
import PosSurvey from './PosSurvey';

const initFind = {
  search: '',
  order_by: 'tb.code',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
  status: 'ALL',
  period: 'ALL',
  date_start: Func.dateTimeFirstMonth(),
  date_stop: Func.dateTimeEndMonth(),
};

const initCart = {
  id: '',
  total: '',
  vat: '',
  amount: '',
  discount: '',
  nettotal: '',
  client_name: '',
  client_tel: '',
  client_country: '',
  country: '',
  sales: '',
  enable_cash: 'N',
  enable_transfer: 'N',
  enable_credit: 'N',
  coupon_id: '0',
  coupon_code: '',
};

const initAttr = {
  id: '',
  name: '',
  home: '',
  image: '',
  mini: '',
  cashier: '',
  pos: '',
  branch: '',
  lastbill: '',
  date_start: '',
  date_round: '',
  height_cart: '430',
  height_campaign: '200',
  size_button: '30',
};

const initInfo = {
  id: '',
  branch: '',
  shift_code: '',
  date_round: '',
  date_start: '',
  cashier: '',
  pos: '',
  lastbill: '',
};

const initLogin = {
  id: '',
  date_expire: '',
  qrcode: '',
};

const initAnnouncement = {
  text: '',
  color: 'info',
  severity: '',
  details: '',
  variant: '',
  alert_icon: '',
  isDismiss: false,
};

async function notifyUser(notificationText = 'Thank you for enable') {
  if (!('Notification' in window)) {
    alert('Browser does not support notifications');
  } else if (Notification.permission === 'granted') {
    const notification = new Notification(notificationText);
  } else if (Notification.permission !== 'denined') {
    await Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        const notification = new Notification(notificationText);
      }
    });
  }
}

function PointOfsale() {
  const mod = 'pointofsale';
  const { t } = useTranslation();
  const app = useSelector((state) => state[Defi.APP_STATE]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [checkoutLoading, setCeckoutLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loadAdd, setLoadAdd] = useState(false);
  const [attr, setAttr] = useState(initAttr);
  const [info, setInfo] = useState(initInfo);
  const [login, setLogin] = useState(initLogin);
  const [cart, setCart] = useState(initCart);
  const [cartList, setCartList] = useState([]);
  const [cboBank, setCboBank] = useState([]);
  const [cboCreditCard, setCboCreditCard] = useState([]);
  const [notify, setNotify] = useState(null);
  const [menu, setMenu] = useState(null);
  const [find, setFind] = useState(initFind);
  const [search, setSearch] = useState('');
  const [quantity, setQuantity] = useState('');
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [textBarcode, setTextBarcode] = useState(false);
  const [blockScan, setBlockScan] = useState(false);
  const [page, setPage] = useState('');
  const [cssRow, setCssRow] = useState('');
  const [campaign, setCampaign] = useState([]);
  const [free, setFree] = useState([]);
  const [modalChange, setModalChange] = useState(false);
  const [changeMoney, setChangeMoney] = useState('');
  const [userResponded, setUserResponded] = useState(false);
  const [miniActive, setMiniActive] = useState(true);
  // const [countKeep, setCountKeep] = useState(0);
  const [countApprove, setCountApprove] = useState(0);
  const [countMessage, setCountMessage] = useState(0);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [announcement, setAnnouncement] = useState(initAnnouncement);
  const txtSearch = useRef(null);
  const barcodeScanRef = useRef('');
  const scanTimeoutRef = useRef(null);
  const closeShiftRef = useRef(null);

  useEffect(() => {
    const checkDevice = () => {
      const ua = window.navigator.userAgent.toLowerCase();
      const isAndroid = /android/i.test(ua);
      const isIOS = /ipad|iphone|ipod/i.test(ua);
      const isTablet =
        /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(
          ua
        );
      const isMobile =
        /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        );

      // const isComputer = !isMobile && !isTablet && !isAndroid && !isIOS;
      return isTablet || isMobile || isAndroid || isIOS;
    };
    setIsMobileDevice(checkDevice());
  }, []);

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const alertDropMoney = () => {
    Swal.fire({
      title: 'กรุณา ดรอปเงิน!',
      text: 'ปริมาณเงินในลิ้นชักถึงจำนวนที่กำหนด',
      icon: 'warning',
    });
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
    })
      .then((result) => {
        if (result.status && result.status === 'ok') {
          setCart(result.cart);
          setCartList(result.cart_list);
          setCampaign(result.campaign);
          setFree(result.free);
          setInfo(result.info);
          if (result.drop === 'Y') {
            alertDropMoney();
          }
          if (
            result.announcement &&
            (result.announcement.text !== announcement.text ||
              result.announcement.color !== announcement.color ||
              result.announcement.severity !== announcement.severity ||
              result.announcement.details !== announcement.details ||
              result.announcement.variant !== announcement.variant ||
              result.announcement.alert_icon !== announcement.alert_icon)
          ) {
            setAnnouncement({
              ...result.announcement,
              isDismiss: false,
            });
          }
        } else if (!result.status) {
          showNotify(t('alert.server_timeout'), 'error');
        }
      })
      .catch((error) => {
        showNotify(t('alert.network_timeout'), 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const reload = () => {
    view(find);
  };

  // const reloadReKeep = (count) => {
  //   setCountKeep(count);
  //   view(find);
  // };

  const add = (barcode) => {
    if (barcode === '') return;
    if (loadAdd) return;

    setLoadAdd(true);
    setBlockScan(true);
    setCssRow('first-row');
    FetchData('PUT', `/${mod}`, app.token, {
      barcode: barcode.split('Shift').join(''),
      quantity: quantity,
    })
      .then((result) => {
        setBlockScan(false);

        if (result.status && result.status === 'ok') {
          setTextBarcode(false);
          setSearch('');
          setQuantity('');

          setCart(result.cart);
          setCartList(result.cart_list);
          setCampaign(result.campaign);
          setFree(result.free);
          setTextBarcode(true);

          if (Number(result.scan?.price) < Number(result.scan?.cost_fix)) {
            Swal.fire({
              title: 'สินค้าชิ้นนี้มีราคาขายต่ำกว่าทุน',
              icon: 'warning',
            });
          }

          setTimeout(function () {
            setTextBarcode(false);
          }, 100);

          setTimeout(function () {
            setCssRow('');
          }, 1000);
        } else if (!result.status) {
          showNotify(t('alert.server_timeout'), 'error');
        } else if (result.status && result.msg.startsWith('!')) {
          Swal.fire({
            title: 'เพิ่มสินค้าไม่สำเร็จ',
            text: result.msg.substring(1),
            icon: 'error',
          });
        } else {
          showNotify(result.msg, 'error');
        }
      })
      .catch((error) => {
        showNotify(t('alert.network_timeout'), 'error');
      })
      .finally(() => {
        setLoadAdd(false);
        setBlockScan(false);
      });
  };

  const addFree = (item) => {
    if (item.id === '') return;
    if (loadAdd) return;

    setLoadAdd(true);
    setCssRow('first-row');
    FetchData('OPTIONS', `/${mod}/addfree`, app.token, {
      id: item.id,
    })
      .then((result) => {
        if (result.status && result.status === 'ok') {
          setTextBarcode(false);
          setSearch('');
          setQuantity('');

          setCart(result.cart);
          setCartList(result.cart_list);
          setCampaign(result.campaign);
          setFree(result.free);
          setTextBarcode(true);

          setTimeout(function () {
            setTextBarcode(false);
          }, 100);

          setTimeout(function () {
            setCssRow('');
          }, 1000);
        } else if (!result.status) {
          showNotify(t('alert.server_timeout'), 'error');
        } else {
          showNotify(result.msg, 'error');
        }
      })
      .catch((error) => {
        showNotify(t('alert.network_timeout'), 'error');
      })
      .finally(() => {
        setLoadAdd(false);
        setBlockScan(false);
      });
  };

  const checkout = () => {
    setCeckoutLoading(true);
    setButtonLoading(true);
    setBlockScan(true);

    FetchData('OPTIONS', `/${mod}/checkout`, app.token, {
      lang: app.lang,
    })
      .then((result) => {
        if (result.status && result.status === 'ok') {
          setCart(result.cart);
          setCartList(result.cart_list);
          setCampaign(result.campaign);
          setFree(result.free);
        } else if (!result.status) {
          showNotify(t('alert.server_timeout'), 'error');
        } else {
          showNotify(result.msg, 'error');
        }
      })
      .catch((error) => {
        showNotify(t('alert.network_timeout'), 'error');
      })
      .finally(() => {
        setCeckoutLoading(false);
        setButtonLoading(false);
        setBlockScan(false);
      });
  };

  const handleNotify = async () => {
    if (app.devicenotify !== '') {
      // onValue(ref(db, `notify/${app.devicenotify}`), (snapshot) => {
      //   const data = snapshot.val();
      //   // console.log(data);
      //   // console.log(app.devicenotify);
      //   if (data.pos_approve !== undefined) {
      //     setCountApprove(data.pos_approve);
      //   }
      //   if (data.count !== undefined) {
      //     setCountMessage(data.count);
      //   }
      // });
      onChildChanged(ref(db, `notify/${app.devicenotify}`), (snapshot) => {
        const { key } = snapshot;
        const value = snapshot.val();
        switch (key) {
          case 'pos_approve':
            setCountApprove(value);
            break;
          case 'count':
            setCountMessage(value);
            break;
          default:
            break;
        }
      });
    }
  };

  const addBarcode = useCallback(
    (barcode) => {
      add(barcode);
    },
    [quantity, loadAdd]
  ); // เพิ่ม dependencies ที่จำเป็น

  const addText = () => {
    add(search);
  };

  // const keep = () => {
  //   Swal.fire({
  //     title: 'คุณต้องการจัดเก็บข้อมูลใช่หรือไม่',
  //     icon: 'warning',
  //     showDenyButton: true,
  //     confirmButtonColor: '#3085d6',
  //     confirmButtonText: t(`element.save`),
  //     denyButtonText: t(`element.cancel`),
  //     denyButtonColor: '#dc3545',
  //     reverseButtons: true,
  //   }).then((swal) => {
  //     if (swal.isConfirmed) {
  //       setLoading(true);

  //       FetchData('OPTIONS', `/${mod}/keep`, app.token, {})
  //         .then((result) => {
  //           if (result.status && result.status === 'ok') {
  //             setSearch('');
  //             setQuantity('');

  //             setCart(result.cart);
  //             setCartList(result.cart_list);
  //             setCampaign(result.campaign);
  //             setFree(result.free);
  //             setCountKeep(result.count_keep);
  //           } else if (!result.status) {
  //             showNotify(t('alert.server_timeout'), 'error');
  //           } else {
  //             showNotify(result.msg, 'error');
  //           }
  //         })
  //         .catch((error) => {
  //           showNotify(t('alert.network_timeout'), 'error');
  //         })
  //         .finally(() => {
  //           setLoading(false);
  //         });
  //     }
  //   });
  // };

  const del = (item) => {
    Swal.fire({
      title: `ขอลบ "${item.product_name}" \nใช่หรือไม่ ?`,
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'ขอลบ',
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        FetchData('OPTIONS', `/${mod}/delrequest`, app.token, {
          id: item.id,
        })
          .then((result) => {
            if (result.status && result.status === 'ok') {
              view(find);
              showNotify(t(`alert.savecomplete`), 'success');
            } else if (!result.status) {
              showNotify(t('alert.server_timeout'), 'error');
            } else {
              showNotify(result.msg, 'error');
            }
          })
          .catch((error) => {
            showNotify(t('alert.network_timeout'), 'error');
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const delCancel = (item) => {
    Swal.fire({
      title: `ยกเลิกขอลบ "${item.product_name}" \nใช่หรือไม่ ?`,
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'ยืนยันการยกเลิก',
      denyButtonText: 'ไม่ยกเลิก',
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('OPTIONS', `/${mod}/delcancel`, app.token, {
          id: item.id,
        })
          .then((result) => {
            if (result.status && result.status === 'ok') {
              view(find);
              showNotify(t(`alert.savecomplete`), 'success');
            } else if (!result.status) {
              showNotify(t('alert.server_timeout'), 'error');
            } else {
              showNotify(result.msg, 'error');
            }
          })
          .catch((error) => {
            showNotify(t('alert.network_timeout'), 'error');
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const cancelReturn = () => {
    Swal.fire({
      title: `ยกเลิกการคืน ใช่หรือไม่ ?`,
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'ยืนยันการยกเลิก',
      denyButtonText: 'ไม่ยกเลิก',
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('OPTIONS', `/${mod}/cancelreturn`, app.token, {})
          .then((result) => {
            if (result.status && result.status === 'ok') {
              setSearch('');
              setQuantity('');

              setCart(result.cart);
              setCartList(result.cart_list);
              setCampaign(result.campaign);
              setFree(result.free);
              showNotify(t(`alert.editcomplete`), 'success');
            } else if (!result.status) {
              showNotify(t('alert.server_timeout'), 'error');
            } else {
              showNotify(result.msg, 'error');
            }
          })
          .catch((error) => {
            showNotify(t('alert.network_timeout'), 'error');
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const btnDel = (item) => {
    if (item.enable === 'Y') {
      return (
        <Tooltip title='ขอลบ'>
          <MDButton variant='text' color='error' size='small' iconOnly onClick={() => del(item)}>
            <Icon>delete</Icon>
          </MDButton>
        </Tooltip>
      );
    }

    return (
      <Tooltip title='ยกเลิก'>
        <MDButton
          variant='text'
          color='secondary'
          size='small'
          iconOnly
          onClick={() => delCancel(item)}
        >
          <Icon>delete</Icon>
        </MDButton>
      </Tooltip>
    );
  };

  const editQuantity = (input) => {
    setQuantity(input);

    // เคลียร์ barcode ที่อาจค้างอยู่เมื่อเปลี่ยน quantity
    if (barcodeScanRef.current) {
      barcodeScanRef.current = '';
      setBarcodeDisplay('');
    }

    // เคลียร์ timeout ที่อาจค้างอยู่
    if (scanTimeoutRef.current) {
      clearTimeout(scanTimeoutRef.current);
      scanTimeoutRef.current = null;
    }

    if (textBarcode && txtSearch.current) {
      // Use requestAnimationFrame for better focus timing
      requestAnimationFrame(() => {
        txtSearch.current.focus();
      });
    }
  };

  const init = () => {
    setLoading(true);
    FetchData('OPTIONS', `/${mod}/init`, app.token, {
      lang: app.lang,
      client: app.client,
    }).then((result) => {
      if (result?.status) {
        if (result.status === 'ok') {
          setPage('pos');
          setAttr(result.data);

          if (result.device !== app.device) {
            dispatch(setDevice(result.device));
          }

          if (result.data.check_change === 'Y') {
            setCboBank(result.bank);
            setCboCreditCard(result.credit);
            setMiniActive(result.data.mini_active === 'Y');
            // setCountKeep(result.data.count_keep);
            setLoading(false);
            view(find);
          } else {
            setModalChange(true);
          }
        } else if (result.status === 'login') {
          localStorage.removeItem('pos_status');
          setLoading(false);
          setAttr(result.data);
          setLogin(result.login);
          setLoading(false);
          setPage('pos');
          if (result.device !== app.device) {
            dispatch(setDevice(result.device));
          }
          setPage('login');
        } else if (result.status === 'exit') {
          setPage('exit');
          window.location.replace('/price_tag');
        } else if (result.status === 'user_not_match') {
          setPage('blank');
          Swal.fire({
            icon: 'error',
            title: 'User ไม่ถูกต้อง',
            text: `กะนี้ถูกเปิดโดย User ${result.user_name}`,
            allowEscapeKey: false,
            allowOutsideClick: false,
            showDenyButton: true,
            confirmButtonText: 'ปิดกะ',
            denyButtonText: 'ออกจากระบบ',
            reverseButtons: true,
          }).then((swal) => {
            if (swal.isConfirmed) {
              closeShiftRef.current.userNotMatch();
            } else if (swal.isDenied) {
              window.location.replace('/logout');
            }
          });
        } else if (result.status === 'close_shift') {
          setPage('blank');
          closeShiftRef.current.closeHistory();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: result.msg,
            allowEscapeKey: false,
            allowOutsideClick: false,
            confirmButtonText: 'ตกลง',
          }).then(() => {
            window.location.replace('/');
          });
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: 'ตกลง',
        }).then(() => {
          window.location.replace('/');
        });
      }
    });
  };

  const saveChange = () => {
    if (changeMoney * 1 <= 0) return;

    setLoading(true);
    setBlockScan(true);

    FetchData('OPTIONS', `/${mod}/savechange`, app.token, {
      lang: app.lang,
      client: app.client,
      change_money: changeMoney,
    })
      .then((result) => {
        if (result.status && result.status === 'ok') {
          window.location.reload();
        } else if (!result.status) {
          showNotify(t('alert.server_timeout'), 'error');
        } else {
          showNotify(result.msg, 'error');
        }
      })
      .catch((error) => {
        showNotify(t('alert.network_timeout'), 'error');
      });
  };

  // const btnKeep = () => {
  //   return (
  //     <MDButton
  //       variant='contained'
  //       color='dark'
  //       size='large'
  //       fullWidth
  //       sx={{ fontSize: attr.size_button * 1 }}
  //       onClick={keep}
  //       disabled={cartList.length === 0 || buttonLoading}
  //     >
  //       <i className='fad fa-inbox-in' /> &nbsp; จัดเก็บ
  //     </MDButton>
  //   );
  // };

  const enableNotiAndClose = async () => {
    await notifyUser().then(() => {
      setUserResponded(true);
    });
  };

  const disableNotiAndClose = () => {
    setUserResponded(true);
  };

  const alertMinScreen = () => {
    if (miniActive) return null;

    return (
      <Tooltip title='หน้าจอเล็กถูกปิด'>
        <IconButton size='small' sx={{ mr: 2 }}>
          <i className='fad fa-desktop' />
        </IconButton>
      </Tooltip>
    );
  };

  const alertScan = () => {
    if (blockScan) {
      return (
        <Tooltip title='ไม่สามารถสแกนได้' sx={{ mr: 2 }}>
          <IconButton size='small'>
            <i className='fad fa-scanner' />
          </IconButton>
        </Tooltip>
      );
    }

    return (
      <Tooltip title='สามารถสแกนบาร์โคดได้' sx={{ mr: 2 }}>
        <IconButton size='small' color='success'>
          <i className='fad fa-scanner' />
        </IconButton>
      </Tooltip>
    );
  };

  const alertApprove = () => {
    return (
      <Tooltip title='รายการอนุมัติ' sx={{ mr: 2 }}>
        <Badge badgeContent={app.badge.pos_approve} color='primary'>
          <IconButton size='small'>
            <i className='fad fa-clipboard-check' />
          </IconButton>
        </Badge>
      </Tooltip>
    );
  };

  const alertNotify = () => {
    if (!userResponded && !(Notification.permission === 'granted')) {
      return (
        <Tooltip title='การแจ้งเตือนถูกปิด' sx={{ mr: 2 }}>
          <IconButton size='small'>
            <i className='fad fa-bell-exclamation' />
          </IconButton>
        </Tooltip>
      );
    }

    return null;
  };

  const renderAppBar = () => {
    return (
      <AppBar
        position='fixed'
        sx={{ backgroundColor: '#ffffff', borderBottom: '1px solid #bdbdbd' }}
        component='nav'
      >
        <Toolbar>
          <MDBox component={NavLink} to={app.home} display='flex' alignItems='center' gap={1}>
            <MDBox
              component='img'
              src={attr.image}
              alt=''
              width='2rem'
              sx={{ borderRadius: '10px' }}
            />
            <MDBox>
              <MDTypography component='h6' variant='button' fontWeight='medium' color='dark'>
                {attr.name}
              </MDTypography>
            </MDBox>
          </MDBox>

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
            }}
          >
            {announcement.text && (
              <Grow in={!announcement.isDismiss} timeout={1000}>
                <Alert
                  variant={announcement.variant || undefined}
                  severity={announcement.severity || undefined}
                  icon={announcement.severity ? undefined : false}
                  color={announcement.color}
                  sx={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    userSelect: 'none',
                  }}
                  onClose={() => {
                    setAnnouncement({ ...announcement, isDismiss: true });
                  }}
                >
                  {announcement.text}
                  {announcement.details && (
                    <>
                      <span> &nbsp;</span>
                      <MDButton
                        color={announcement.variant !== 'filled' ? announcement.color : 'white'}
                        size='small'
                        variant='outlined'
                        onClick={() => {
                          Swal.fire({
                            title: announcement.text,
                            text: announcement.details,
                            icon: announcement.alert_icon,
                            confirmButtonText: 'ตกลง',
                          });
                        }}
                      >
                        ดูรายละเอียด
                      </MDButton>
                    </>
                  )}
                </Alert>
              </Grow>
            )}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            {alertNotify()}
            {alertMinScreen()}
            {/* <PosReKeep reload={reloadReKeep} setBlockScan={setBlockScan} count={countKeep} /> */}
            <PosMessage reload={reload} setBlockScan={setBlockScan} count={countMessage} />
            <PosApprove reload={reload} setBlockScan={setBlockScan} count={countApprove} />
            <IconButton onClick={(e) => setMenu(e.currentTarget)} sx={{ p: 0 }}>
              <Icon>menu</Icon>
            </IconButton>
            <Menu
              sx={{ mt: '45px' }}
              id='menu-appbar'
              anchorEl={menu}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(menu)}
              onClose={() => setMenu(null)}
            >
              <MenuItem
                onClick={() => {
                  setMenu(null);
                  window.open('/posmini', '_blank');
                }}
              >
                <Typography>
                  <Icon color='info'>monitor</Icon> เปิดหน้าจอเล็ก
                </Typography>
              </MenuItem>
              {/* <PosReportShift setMenu={setMenu} /> */}
              <PosCloseShift ref={closeShiftRef} setBlockScan={setBlockScan} setMenu={setMenu} />
              <PosShortKey setMenu={setMenu} />
              {!userResponded && !(Notification.permission === 'granted') ? (
                <MenuItem
                  onClick={() => {
                    setMenu(null);
                    enableNotiAndClose();
                  }}
                >
                  <Typography>
                    <Icon color='error'>notifications_active</Icon> เปิดการแจ้งเตือน
                  </Typography>
                </MenuItem>
              ) : null}
              {/* {miniActive ? (
                <MenuItem
                  onClick={() => {
                    setMenu(null);
                    closeMiniActive();
                  }}
                >
                  <Typography>
                    <Icon color='dark'>desktop_access_disabled</Icon> ปิดหน้าจอเล็ก
                  </Typography>
                </MenuItem>
              ) : (
                <MenuItem
                  onClick={() => {
                    setMenu(null);
                    openMiniActive();
                  }}
                >
                  <Typography>
                    <Icon color='success'>browser_updated</Icon> แสดงหน้าจอเล็ก
                  </Typography>
                </MenuItem>
              )} */}
              <Divider />
              <MenuItem
                onClick={() => {
                  setMenu(null);
                }}
              >
                <Link href='/logout'>
                  <Typography textAlign='center'>
                    <Icon color='dark'>logout</Icon> ออกจากระบบ
                  </Typography>
                </Link>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    );
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
            {textBarcode ? (
              <MDBox
                noValidate
                component='form'
                role='form'
                onSubmit={(e) => {
                  e.preventDefault();
                  addText();
                }}
              >
                <MDInput
                  name='search'
                  type='text'
                  fullWidth
                  onChange={(e) => setSearch(e.target.value)}
                  sx={{ input: { color: '#000', fontSize: '15px' } }}
                  value={search}
                  InputProps={{
                    inputRef: txtSearch,
                    maxLength: 50,
                    autoFocus: true,
                    inputProps: {
                      autoComplete: 'off',
                    },
                    startAdornment: (
                      <InputAdornment position='start'>
                        <MDTypography variant='body' color='dark' sx={{ width: 65 }}>
                          BARCODE :
                        </MDTypography>
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position='end'>
                        <MDButton
                          variant='contained'
                          color='dark'
                          size='small'
                          iconOnly
                          onClick={() => {
                            setTextBarcode(false);
                            setSearch('');
                          }}
                        >
                          <Icon>reply</Icon>
                        </MDButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </MDBox>
            ) : (
              <Tooltip title='key : F2'>
                <MDButton
                  variant='outlined'
                  color='dark'
                  size='large'
                  fullWidth
                  sx={{ display: 'inline-block', textAlign: 'left' }}
                  onClick={() => {
                    setTextBarcode(true);
                    // Use requestAnimationFrame for immediate focus
                    requestAnimationFrame(() => {
                      if (txtSearch.current) {
                        txtSearch.current.focus();
                      }
                    });
                  }}
                >
                  <i
                    className={
                      blockScan ? 'fad fa-siren color-default' : 'fad fa-siren-on color-warning'
                    }
                  />{' '}
                  Barcode : {barcodeDisplay}
                </MDButton>
              </Tooltip>
            )}
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
            <PosQuantity
              quantity={quantity}
              setQuantity={setQuantity}
              callback={editQuantity}
              setBlockScan={setBlockScan}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={1} align='center'>
            <PosProduct callback={add} setBlockScan={setBlockScan} />
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={1} align='center'>
            <MDButton
              variant='text'
              color='dark'
              size='large'
              sx={{ fontSize: 23 }}
              onClick={() => window.location.reload()}
            >
              <i className='fad fa-sync-alt' />
            </MDButton>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const renderSummary = () => {
    const discountRequest = () => {
      if (cart.discount_request * 1 > 0) {
        if (cart.discount_type === 'P') {
          return <span>ขอส่วนลด {Func.numberDisplay(cart.discount_request, 2)} % :</span>;
        }

        return <span>ขอส่วนลด {Func.numberDisplay(cart.discount_request, 2)} ฿ :</span>;
      }

      return 'ขอส่วนลด :';
    };

    return (
      <TableContainer component={Paper}>
        <Table aria-label='summary table'>
          <TableBody>
            {/* {cart.problem_type === "return" ? (
              <TableRow>
                <TableCell>
                  <MDBox pl={2}>
                    <MDTypography variant="h3" className="nowrap">
                      คืนสินค้า
                    </MDTypography>
                  </MDBox>
                </TableCell>
                <TableCell align="right">
                  <MDButton variant="text" color="error" size="small" onClick={cancelReturn}>
                    <Icon>cancel</Icon> ยกเลิก
                  </MDButton>
                </TableCell>
              </TableRow>
            ) : null} */}

            {/* <TableRow>
              <TableCell align="right">
                <MDTypography variant="h4" className="nowrap">
                  มูลค่าสินค้า :
                </MDTypography>
              </TableCell>
              <TableCell align="right">
                <MDTypography variant="h4" className="nowrap">
                  {Func.numberDisplay(cart.amount, 2)} ฿
                </MDTypography>
              </TableCell>
            </TableRow> */}
            {/* <TableRow>
              <TableCell align="right">
                <MDTypography variant="h4" className="nowrap">
                  ภาษี :
                </MDTypography>
              </TableCell>
              <TableCell align="right">
                <MDTypography variant="h4" className="nowrap">
                  {Func.numberDisplay(cart.vat, 2)} ฿
                </MDTypography>
              </TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell align='right'>
                <MDTypography variant='h4' className='nowrap'>
                  มูลค่ารวม :
                </MDTypography>
              </TableCell>
              <TableCell align='right'>
                <MDTypography variant='h4' className='nowrap'>
                  {Func.numberDisplay(cart.total, 2)} ฿
                </MDTypography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align='right'>
                <MDTypography variant='h4' className='nowrap'>
                  คูปอง :
                </MDTypography>
              </TableCell>
              <TableCell align='right'>
                {cart.discount_coupon * 1 > 0 ? (
                  <MDTypography variant='h4' className='nowrap'>
                    {Func.numberDisplay(cart.discount_coupon, 2)} ฿
                  </MDTypography>
                ) : (
                  '-'
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align='right'>
                <MDTypography variant='h4' className='nowrap'>
                  โปรโมชั่น :
                </MDTypography>
              </TableCell>
              <TableCell align='right'>
                {cart.discount * 1 > 0 ? (
                  <MDTypography variant='h4' className='nowrap'>
                    {Func.numberDisplay(cart.discount, 2)} ฿
                  </MDTypography>
                ) : (
                  '-'
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align='right'>
                <MDTypography variant='h4' className='nowrap'>
                  {discountRequest()}
                </MDTypography>
              </TableCell>
              <TableCell align='right'>
                {cart.discount_approve * 1 > 0 ? (
                  <MDTypography variant='h4' className='nowrap'>
                    {Func.numberDisplay(cart.discount_approve, 2)} ฿
                  </MDTypography>
                ) : (
                  '-'
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align='right'>
                <MDTypography variant='h4' className='nowrap'>
                  คืนสินค้า :
                </MDTypography>
              </TableCell>
              <TableCell align='right'>
                {cart.problem_type === 'return' ? (
                  <MDTypography variant='h4' className='nowrap'>
                    - {Func.numberDisplay(cart.return_total, 2)} ฿
                  </MDTypography>
                ) : (
                  '-'
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align='right'>
                <MDTypography variant='h4' className='nowrap'>
                  รวมทั้งสิ้น :
                </MDTypography>
              </TableCell>
              <TableCell align='right'>
                <MDTypography variant='h4' color='info' className='nowrap'>
                  {Func.numberDisplay(cart.nettotal, 2)} ฿
                </MDTypography>
              </TableCell>
            </TableRow>
            {cart.pay_split === 'Y' ? (
              <TableRow>
                <TableCell align='right'>
                  <MDTypography variant='h4' className='nowrap'>
                    ชำระแล้ว :
                  </MDTypography>
                </TableCell>
                <TableCell align='right'>
                  <MDTypography variant='h4' color='error' className='nowrap'>
                    {Func.numberDisplay(cart.paid, 2)} ฿
                  </MDTypography>
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const pharmacyDisplay = (row) => {
    if (row.pharmacy === 'Y') {
      if (row.medicine === 'Y') {
        return (
          <MDBox className='nowrap'>
            <i className='fas fa-prescription color-success' /> ยาสามัญ
          </MDBox>
        );
      }

      return (
        <MDBox className='nowrap'>
          <i className='fas fa-prescription color-danger' /> ยารักษา
        </MDBox>
      );
    }

    return null;
  };

  const isBelowCost = (row) => row.below_cost === 'Y';

  const renderList = () => {
    return (
      <MDBox mt={1}>
        <TableContainer component={Paper} sx={{ height: attr.height_cart * 1 }}>
          <Table aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell align='center' width={20}>
                  No.
                </TableCell>
                <TableCell width={100}>Barcode</TableCell>
                <TableCell>สินค้า</TableCell>
                <TableCell align='center' className='nowrap'>
                  ประเภทยา
                </TableCell>
                <TableCell align='right' width={90}>
                  ราคา
                </TableCell>
                <TableCell align='right' width={90}>
                  จำนวน
                </TableCell>
                <TableCell align='left' width={50}>
                  หน่วย
                </TableCell>
                <TableCell align='right' width={90}>
                  รวม
                </TableCell>
                <TableCell width={10}>&nbsp;</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cartList.map((row, i) => (
                <TableRow
                  hover
                  key={row.id}
                  className={[i === 0 ? cssRow : '', isBelowCost(row) ? 'row-below-cost' : '']
                    .filter(Boolean)
                    .join(' ')}
                >
                  <TableCell align='center'>{i + 1}</TableCell>
                  <TableCell className={isBelowCost(row) ? 'color-danger' : ''}>
                    {row.barcode}
                  </TableCell>
                  <TableCell className={isBelowCost(row) ? 'color-danger' : ''}>
                    <MDBox width={400}>{row.product_name}</MDBox>
                  </TableCell>
                  <TableCell align='center'>{pharmacyDisplay(row)}</TableCell>
                  <TableCell align='right' className={isBelowCost(row) ? 'color-danger' : ''}>
                    {row.price * 1 > 0 ? Func.numberDisplay(row.price) : 'Free'}
                  </TableCell>
                  <TableCell align='right' className={i === 0 ? 'color-danger' : ''}>
                    {Func.numberDisplay(row.quantity_all)}
                  </TableCell>
                  <TableCell align='left' className='nowrap'>
                    {row.unit_name}
                  </TableCell>
                  <TableCell align='right'>
                    {row.free === 'Y' || row.after_discount * 1 <= 0
                      ? 'Free'
                      : Func.numberDisplay(row.after_discount)}
                  </TableCell>
                  <TableCell align='right'>{btnDel(row)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </MDBox>
    );
  };

  const renderCampaign = () => {
    const promotionDisplay = (inp) => {
      if (inp === 'A') return 'A : ซื้อครบจำนวนลดราคา';
      if (inp === 'B') return 'B : ซื้อครบมูลค่าได้ของแถม';
      if (inp === 'C') return 'C : ซื้อครบจำนวนได้ของแถม';
      if (inp === 'D') return 'D : ยิ่งซื้อยิ่งลด';
      if (inp === 'E') return 'E : ซื้อครบมูลค่าได้ส่วนลด';
      return '';
    };

    return (
      <MDBox mt={1}>
        <TableContainer sx={{ height: attr.height_campaign * 1, boxShadow: 0 }}>
          <Table aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>โปรโมชั่น</TableCell>
                <TableCell>ประเภท</TableCell>
                <TableCell align='right'>ส่วนลด/ของแถม</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {campaign.map((row, i) => (
                <TableRow className='row-order' key={row.id}>
                  <TableCell width={80}>{row.code}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{promotionDisplay(row.promotion_type)}</TableCell>
                  <TableCell align='right'>{Func.numberDisplay(row.discount, 2)}</TableCell>
                </TableRow>
              ))}
              {free.map((row) => (
                <TableRow className='row-order' key={row.id}>
                  <TableCell width={80}>{row.code}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{promotionDisplay(row.promotion_type)}</TableCell>
                  <TableCell align='right'>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' gap={1}>
                      <PosSelectFree
                        parent={row}
                        callback={addFree}
                        setBlockScan={setBlockScan}
                        disabled={Number(row.sum_qty) >= Number(row.limit_qty)}
                      />

                      {Func.numberDisplay(row.sum_discount, 2)}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </MDBox>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderExit = () => {
    return (
      <DashboardLayout>
        <Navbar route={[t(`menu.sale`), t(`menu.pos`)]} />
        <Card sx={{ p: 2 }}>
          <MDTypography variant='body'>ไม่สามารถเข้าใช้งาน</MDTypography>
        </Card>
      </DashboardLayout>
    );
  };

  const renderBlank = () => {
    return <PageLayout>{renderAppBar()}</PageLayout>;
  };

  const renderLogin = () => {
    return (
      <PageLayout>
        {renderAppBar()}
        <MDBox className='text-center' mt={15}>
          <MDBox>
            <img src={login.qrcode} alt='' />
          </MDBox>
          <MDTypography variant='h3' color='secondary'>
            สแกนเข้าสู่ระบบ
          </MDTypography>
          <MDTypography variant='body2' color='secondary'>
            หมดอายุ : {Func.dateTimeDisplay(login.date_expire)}
          </MDTypography>
          <MDBox mt={3}>
            <MDButton
              variant='contained'
              color='secondary'
              onClick={() => window.location.reload()}
            >
              <Icon>refresh</Icon> Reload
            </MDButton>
          </MDBox>
        </MDBox>
        {renderLoading()}
        {notify}
      </PageLayout>
    );
  };

  const renderButton = () => {
    return (
      <MDBox mt={2}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <Tooltip title={cartList.length === 0 ? '' : 'KEY : W'}>
              <MDButton
                variant='contained'
                color='info'
                size='large'
                fullWidth
                sx={{ fontSize: attr.size_button * 1 }}
                onClick={checkout}
                disabled={cartList.length === 0 || checkoutLoading || buttonLoading}
              >
                {checkoutLoading ? (
                  <CircularProgress sx={{ fontSize: attr.size_button * 1 }} color='inherit' />
                ) : (
                  <i className='fad fa-sigma' />
                )}
                &nbsp; รวมยอด
              </MDButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12} md={6}>
            <PosCash
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              isDisabled={cart.enable_cash === 'N'}
              isMobileDevice={isMobileDevice}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosTransfer
              cboBank={cboBank}
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              isDisabled={cart.enable_transfer === 'N'}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosCreditCard
              cboCreditCard={cboCreditCard}
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              isDisabled={cart.enable_credit === 'N'}
              isMobileDevice={isMobileDevice}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosCheckPro
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosClient
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              parent={cart}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosSales
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              parent={cart}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <PosBillHistory
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
              lastbill={info.lastbill}
            />
          </Grid> */}
          {/* <Grid item xs={12} md={6}>
            {btnKeep()}
          </Grid> */}
          <Grid item xs={12} md={6}>
            <PosPayment
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              isDisabled={cartList.length === 0}
              isMobileDevice={isMobileDevice}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosStay
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosDiscount
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosCoupon
              cartId={cart.id}
              couponId={cart.coupon_id}
              couponCode={cart.coupon_code}
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosReturn
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosCancelBill
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PosDropMoney
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <PosSurvey
              reload={reload}
              setBlockScan={setBlockScan}
              sizeButton={attr.size_button * 1}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderCheckChange = () => {
    return (
      <Dialog
        open={modalChange}
        maxWidth='xs'
        keepMounted
        aria-describedby='dialog-change'
        fullWidth
      >
        <DialogTitle>นับเงินทอน</DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>
            <MDInput
              label='จำนวนเงินทอน'
              type='number'
              onChange={(e) => setChangeMoney(e.target.value)}
              value={changeMoney}
              variant='standard'
              fullWidth
              InputProps={{
                endAdornment: <InputAdornment position='end'>บาท</InputAdornment>,
                inputProps: {
                  placeholder: '0',
                  autoComplete: 'off',
                  className: 'text-right',
                },
              }}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Grid container>
            <Grid item xs={6}>
              <PosPrintChange />
            </Grid>
            <Grid item xs={6} display='flex' justifyContent='flex-end'>
              <MDButton variant='text' color='success' onClick={saveChange}>
                <Icon>save</Icon>&nbsp;บันทึกเงินทอน
              </MDButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  };

  const renderFooter = () => {
    return (
      <MDBox mt={2}>
        <MDBox display='flex' gap={1}>
          <Chip label={`สาขา : ${info.branch}`} variant='outlined' />
          <Chip label={`รหัสรอบ : ${info.shift_code}`} variant='outlined' />
          <Chip label={`รอบ : ${info.date_round}`} variant='outlined' />
          <Chip label={`เข้างาน : ${info.date_start}`} variant='outlined' />
          <Chip label={`Cashier code : ${attr.cashier_code}`} variant='outlined' />
          <Chip label={`Cashier : ${info.cashier}`} variant='outlined' />
          <Chip label={`บิลล่าสุด : ${info.lastbill}`} variant='outlined' />
          <Chip label={`รหัสตะกร้า : #${cart.id}`} variant='outlined' />
        </MDBox>
      </MDBox>
    );
  };

  const renderPage = () => {
    return (
      <PageLayout>
        {renderAppBar()}
        <MDBox p={1} mt={8}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={7} lg={8} xl={8}>
              {renderSearch()}
              {renderList()}
              {renderCampaign()}
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={4} xl={4}>
              {renderSummary()}
              {renderButton()}
            </Grid>
            <Grid item xs={12}>
              {renderFooter()}
            </Grid>
          </Grid>
        </MDBox>
        {renderCheckChange()}
        {renderLoading()}
        {notify}
        <PosBillRecovery lastbill={info.lastbill} />
      </PageLayout>
    );
  };

  useHotkeys('f2', () => setTextBarcode(true));
  // useHotkeys('k', () => keep());
  useHotkeys('w', () => checkout());

  // Auto focus when textBarcode becomes true
  useEffect(() => {
    if (textBarcode && txtSearch.current) {
      requestAnimationFrame(() => {
        txtSearch.current.focus();
      });
    }
  }, [textBarcode]);

  useEffect(() => {
    i18n.changeLanguage(app.lang);
    init();
  }, []);

  useEffect(() => {
    handleNotify();
  }, []);

  useEffect(() => {
    const currentHandleKeyDown = (e) => {
      if (!blockScan && !textBarcode) {
        if (e.keyCode === 13 && barcodeScanRef.current.length > 4) {
          setBarcodeDisplay(barcodeScanRef.current);
          const scannedBarcode = barcodeScanRef.current;
          // Clear barcode immediately after capture
          barcodeScanRef.current = '';
          setBarcodeDisplay('');
          // Clear any pending timeout
          if (scanTimeoutRef.current) {
            clearTimeout(scanTimeoutRef.current);
            scanTimeoutRef.current = null;
          }
          // เรียกใช้ add โดยตรงเพื่อใช้ค่า quantity ปัจจุบัน
          add(scannedBarcode);
          return;
        }
      }

      barcodeScanRef.current += e.key;

      // Clear previous timeout
      if (scanTimeoutRef.current) {
        clearTimeout(scanTimeoutRef.current);
      }

      // Set new timeout
      scanTimeoutRef.current = setTimeout(() => {
        barcodeScanRef.current = '';
        setBarcodeDisplay(barcodeScanRef.current);
      }, 500);
    };

    document.addEventListener('keydown', currentHandleKeyDown);

    return function cleanup() {
      document.removeEventListener('keydown', currentHandleKeyDown);
      // Clear timeout on cleanup
      if (scanTimeoutRef.current) {
        clearTimeout(scanTimeoutRef.current);
      }
      // Clear barcode scan ref
      barcodeScanRef.current = '';
    };
  }, [blockScan, textBarcode, quantity, loadAdd]); // เพิ่ม quantity และ loadAdd เพื่อให้ add function ได้รับค่าปัจจุบัน

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      if (scanTimeoutRef.current) {
        clearTimeout(scanTimeoutRef.current);
      }
      barcodeScanRef.current = '';
    };
  }, []);

  return page === 'pos'
    ? renderPage()
    : page === 'exit'
    ? renderExit()
    : page === 'login'
    ? renderLogin()
    : renderBlank();
}

export default PointOfsale;
